import { DateRange } from "./types";

const PAGES_KEPT_EACH_SIDE = 5;

// Remembers fetched pages for one set of dates + filters; a different set starts fresh.
export function createPageCache<T>() {
  let currentKey = "";
  let pages = new Map<number, T>();

  return {
    isNewKey: (key: string) => key !== currentKey,
    get: (key: string, page: number) => (key === currentKey ? pages.get(page) : undefined),
    set: (key: string, page: number, data: T) => {
      if (key !== currentKey) {
        currentKey = key;
        pages = new Map();
      }
      pages.set(page, data);
      pages.forEach((_, p) => {
        if (Math.abs(p - page) > PAGES_KEPT_EACH_SIDE) pages.delete(p);
      });
    },
  };
}

export const pageCacheKey = (dateRange: DateRange, filters: unknown) =>
  JSON.stringify({ start: dateRange[0]?.toISOString(), end: dateRange[1]?.toISOString(), filters });
